import { Injectable } from '@angular/core';
import { GeneralService } from './general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { AppLoadingService } from './apploading.service';
import { API } from 'src/app/configs';
import { MatDialog } from '@angular/material/dialog';
import { ReasonComponent } from '../components/reason/reason.component';

@Injectable({
    providedIn: 'root'
})
export class RequestRestrictedService {

    authorizationContinue:any = null;
    constructor(
        
        protected httpService: HttpService,
        protected gs: GeneralService,
        protected als: AppLoadingService,
        public dialog: MatDialog,
    ) {

    }

    async authorize(data, callback){
        await this.als.setLoaded(false, 'restrictedAuthorize');
        await this.httpService.post<any>(API.ad.general.restricted.allow, {
          "owner_person_id": data.owner_person_id,
          "person_request_id": data.person_request_id,
          "update": data.update
        })
          .then(async result => {
            this.gs.error({}, 'Acesso restrito autorizado');
            this.gs.transactionData.next({method:'requestRestricted', action:'reload'});
            callback(true);
          })
          .catch((err) => {
            this.gs.error(err);
            callback(false);
          })
          .finally(() => {
            this.als.setLoaded(true, 'restrictedAuthorize');
          });
    }

    async reject(data, callback){
        let modalId = 'ReasonComponent_'+Math.random();
        const dialogRef = this.dialog.open(ReasonComponent, 
        {   disableClose : true,
            id:modalId,
            data: {
              modalId:modalId,
              subtitle : 'Caso não queira justificar a rejeição, deixe o campo vazio'
            }
        });
        dialogRef.afterClosed().subscribe(async result => {
          if(typeof result?.reason != 'undefined'){
            this.als.setLoaded(false, 'restrictedReject');
            await this.httpService.post<any>(API.ad.general.restricted.reject, {
              "owner_person_id": data.owner_person_id,
              "person_request_id": data.person_request_id,
              "update": data.update,
              "message" : result.reason
            })
              .then(async result => {
                console.log(result);
                this.gs.error({}, 'Acesso restrito rejeitado');
                this.gs.transactionData.next({method:'requestRestricted', action:'reload'});
                callback(true);
              })
              .catch((err) => {
                this.gs.error(err);
                callback(false);
              })
              .finally(() => {
                this.als.setLoaded(true, 'restrictedReject');
              });
          }
        });
    }

}